"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOW = exports.MEDIUM = exports.HIGH = void 0;
var HIGH = 'high';
exports.HIGH = HIGH;
var MEDIUM = 'medium';
exports.MEDIUM = MEDIUM;
var LOW = 'low';
exports.LOW = LOW;